module.exports = __webpack_public_path__ + "img/Kraftfahrzeug_Geländegängig.dcbd302c.svg";